import React from 'react';
import classnames from 'classnames';
import Gallery from './Gallery';

import image1 from '../images/WorkDocs-1.jpg';
import image2 from '../images/WorkDocs-2.jpg';
import image3 from '../images/WorkDocs-3.jpg';
import image4 from '../images/WorkDocs-4.jpg';

import '../styles/WorkDocs.css';

class WorkDocs extends React.Component {

  render() {
    return (
      <div className={classnames('WorkDocs', this.props.className)}>
        <Gallery
          className="WorkDocs-gallery"
          items={[
            { image: image1 },
            { image: image2 },
            { image: image3 },
            { image: image4 }
          ]}
          metricsName="WorkDocs"
        />
        <div className="WorkDocs-container">
          <h2 className="WorkDocs-title">
            {`Amazon WorkDocs`}
          </h2>
          <h3 className="WorkDocs-subtitle">
            {`The iOS Engineering and Design Lead `}
          </h3>
          <p className="WorkDocs-description">
            <span>{`Amazon WorkDocs is a fully managed, secure enterprise storage and sharing service with strong administrative controls and feedback capabilities that improve user productivity. `}</span>
            <a
              className="WorkDocs-link"
              href="http://aws.amazon.com/workdocs/"
              target="_blank"
              rel="noopener noreferrer">
              {`aws.amazon.com/workdocs/`}
            </a>
          </p>
          <p className="WorkDocs-year">
            {`2013 to 2015`}
          </p>
        </div>
      </div>
    );
  }

}

export default WorkDocs;



// WEBPACK FOOTER //
// ./src/components/WorkDocs.js